import React from "react";
import {
  dataDefaultFetch,
  patchDataAPI,
  postDataAPI,
} from "../../../../utils/fetchData";
import { Form, Input, message, Select } from "antd";
import { useSelector } from "react-redux";
import { slugUrls } from "../../../../utils/validations";

export default function AdjustFormUrlDirect({
  form,
  setOpen,
  setPage,
  selectedRows,
  setSelectedRowKeys,
  dataUrls,
}) {
  console.log("🚀 ~ AdjustFormUrlDirect ~ dataUrls:", dataUrls);
  const auth = useSelector((state) => state.auth);

  const data = {
    ...dataDefaultFetch,
    data: [
      {
        label: <span>Default Urls</span>,
        title: "Default Urls",
        options: [
          { label: "Home Page", value: "home" },
          { label: "Tour Page", value: "tour" },
          { label: "Book Page", value: "book" },
          { label: "Contact Page", value: "contact" },
          { label: "Blog Page", value: "blog" },
        ],
      },
    ],
  };

  const [dataUrl, setDataUrl] = React.useState(data);

  async function getBlogUrls() {
    try {
      setDataUrl({ ...dataUrl, loading: true });
      const { data } = await postDataAPI("blog/all", {
        page: 0,
        limit_page: 5,
        filters: { is_delete: false },
      });
      if (data?.data?.length > 0) {
        const saveUrls = [...dataUrl.data];
        saveUrls.push({
          label: "Blog Urls",
          title: "Blog Urls",
          options: data?.data?.map((i) => {
            return {
              label: i?.title,
              value: `blog/${i?.slug}`,
            };
          }),
        });
        setDataUrl({
          ...dataUrl,
          data: saveUrls,
          loading: false,
        });
      }
    } catch (error) {
      setDataUrl({ ...dataUrl, loading: false, error: error });
    }
  }

  React.useEffect(() => {
    getBlogUrls();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (form.getFieldValue("url")) {
      setSelectedRowKeys([]);
      Object.keys(form.getFieldValue("url")).forEach((k) => {
        form.setFieldValue(k, form.getFieldValue("url")[k]);
      });
    } else {
      form.resetFields();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  React.useState(() => {});

  const resetAfterSuccess = () => {
    setTimeout(() => {
      form.resetFields();
    }, 1200);
    setOpen(false);
  };

  const add = async (e) => {
    try {
      await postDataAPI(
        "urlsRed/add",
        { ...e, slug: e.origin_url },
        auth?.token
      );
      message.success("Tạo thành công url !");
      setPage({
        filters: { is_delete: false },
        page: 0,
        limit_page: 5,
      });
      resetAfterSuccess();
    } catch (error) {
      message.error(
        error?.response?.data?.statusText ||
          error?.response?.data?.msg ||
          `${error?.response?.status}-${error?.response?.statusText}`
      );
    }
  };
  const edit = async (e) => {
    try {
      await patchDataAPI(
        `urlsRed/edit/${form.getFieldValue("url")?._id}`,
        { target_url: e.target_url },
        auth?.token
      );
      message.success("Sửa thành công url !");
      setPage((s) => ({ ...s }));
      form.setFieldValue("url", null);
      resetAfterSuccess();
    } catch (error) {
      message.error(
        error?.response?.data?.statusText ||
          error?.response?.data?.msg ||
          `${error?.response?.status}-${error?.response?.statusText}`
      );
    }
  };

  const del = async (e) => {
    try {
      await postDataAPI(
        `urlsRed/del`,
        { isDel: true, ids: selectedRows },
        auth?.token
      );
      message.success(`Xoá thành công !`);

      resetAfterSuccess();
      setSelectedRowKeys([]);
      console.log(selectedRows);
      setPage((s) => {
        return {
          ...s,
          limit_page: 5,
          page: ((selectedRows.length === dataUrls?.length) && s.page > 0) ? --s.page : s.page,
        };
      });
    } catch (error) {
      message.error(
        error?.response?.data?.statusText ||
          error?.response?.data?.msg ||
          `${error?.response?.status}-${error?.response?.statusText}`
      );
    }
  };

  const handleSubmitUrl = async (e) => {
    if (!selectedRows.length) {
      if (!form.getFieldValue("url")) {
        add(e);
      } else {
        edit(e);
      }
    } else {
      del(e);
    }
  };

  return (
    <Form
      name="contents"
      form={form}
      onFinish={handleSubmitUrl}
      autoComplete="off"
      layout="vertical"
    >
      {!selectedRows.length ? (
        <>
          <Form.Item
            label="New Url"
            name="origin_url"
            rules={[
              { required: true, message: "Please input the new url!" },
              {
                pattern: new RegExp(slugUrls),
                message: "Hãy nhập đúng format một đuôi url !",
              },
            ]}
          >
            <Input
              prefix={`${window.location.origin}`}
              disabled={form.getFieldValue("url")}
            />
          </Form.Item>
          <Form.Item
            label="Target Url"
            name="target_url"
            rules={[
              { required: true, message: "Please input the target url!" },
            ]}
          >
            <Select
              placeholder="Choose a target url"
              options={dataUrl.data}
              loading={dataUrl.loading}
            />
          </Form.Item>
        </>
      ) : (
        <span>
          Do you want to delete these url{" "}
          {`${selectedRows.map((item) => item.slice(-4)).join(", ")}`}
        </span>
      )}
    </Form>
  );
}
